import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { RiDeleteBin5Fill } from "react-icons/ri";
import Loadings from "./Loading";
import axios from "axios";

const NurseSingup = () => {
  const inputRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [userdata, setUserData] = useState();
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const [inputHandle, setInputHandle] = useState({
    name: "",
    email: "",
    mobile: "",
    designation: "",
    image: "",
    place: "Satkhira Medical College Hospital, Satkhira",
  });
  const { name, email, mobile, designation, place } = inputHandle;

  const handleInput = (e) => {
    const name = e.target.name;
    setInputHandle({ ...inputHandle, [name]: e.target.value });
  };

  // FORM SUBMIT HERE
  const handleSubmit = async (e) => {
    const formData = new FormData();
    formData.append("name", name);
    formData.append("email", email);
    formData.append("mobile", mobile);
    formData.append("designation", designation);
    formData.append("place", place);
    formData.append("file", selectedFile);

    e.preventDefault();
    const UPLOAD_URL = "/nurse";
    axios
      .post(UPLOAD_URL, formData)
      .then(() => {
        NurseData();

        setInputHandle({
          ...inputHandle,
          name: "",
          email: "",
          mobile: "",
          designation: "",
        });
        inputRef.current.value = null;
        setError(false);
      })
      .catch(() => {
        setError(true);
      });
  };

  // Check user Authenticate or not
  const Auth = async () => {
    try {
      const res = await fetch("/root", {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        credentials: "include",
      });
      const data = await res.json();
      if (res.status === 200) {
        setUserData(data);
      } else {
        console.log("Not response found");
      }
    } catch (err) {
      console.log(err);
      navigate("/root", { replace: true });
    }
  };

  useEffect(() => {
    Auth();
  }, []);

  // GET Nurse Data from database
  const [nurseData, setNurseData] = useState([]);
  const [selectedFile, setSelectedFile] = useState();

  const NurseData = () => {
    axios
      .get("/nurse")
      .then((res) => {
        setNurseData(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    NurseData();
  }, []);

  // Nurse Data delete
  const handleDelete = async (_id) => {
    const URL = "/nurse";
    const res = await fetch(URL + `/${_id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
    await res.json();
    if (res.status === 201) {
      NurseData();
      window.alert("Delete Successfull");
    } else if (res.status === 404) {
      console.log("Data not delete");
    }
  };

  return (
    <>
      {isLoading && <Loadings />}
      <form
        method="post"
        encType="multipart/form-data"
        onSubmit={handleSubmit}
        className="bg-gradient-to-r from-indigo-100 via-purple-300 to-pink-100 min-h-screen flex flex-col"
      >
        <div className="container max-w-sm mx-auto flex-1 flex flex-col items-center justify-center px-2">
          <div className="bg-transparent px-6 py-8 rounded shadow-xl text-black w-full">
            <h1 className="mb-8 text-3xl text-center">Sign up</h1>
            <input
              type="text"
              ref={inputRef}
              className="block border border-grey-light w-full p-3 rounded mb-4"
              name="name"
              onChange={handleInput}
              value={name}
              placeholder="Full Name"
              required
            />

            <input
              type="text"
              ref={inputRef}
              className="block border border-grey-light w-full p-3 rounded mb-4"
              name="email"
              onChange={handleInput}
              value={email}
              placeholder="Email"
              required
            />
            <input
              type="text"
              ref={inputRef}
              className="block border border-grey-light w-full p-3 rounded mb-4"
              name="mobile"
              onChange={handleInput}
              value={mobile}
              placeholder="Mobile number (Optional)"
            />

            <select
              name="designation"
              ref={inputRef}
              className="block border border-grey-light w-full p-3 rounded mb-4"
              id="designation"
              onChange={handleInput}
              value={designation}
              required
            >
              <option className="text-red-500">Select Designation</option>
              <option value="Senior Staf Nurse">Senior Staf Nurse</option>
              <option value=" Senior Staf Nurse (CCU Incharge*)">
                Senior Staf Nurse (CCU Incharge*)
              </option>
              <option value=" Senior Staf Nurse (ECHO Incharge*)">
                Senior Staf Nurse (ECHO Incharge*)
              </option>
            </select>

            <input
              type="file"
              ref={inputRef}
              className="block border border-grey-light w-full p-3 rounded mb-4"
              name="file"
              onChange={(e) => setSelectedFile(e.target.files[0])}
            />
            <div className={`${error ? "block" : "hidden"}`}>
              <h2 className="text-center font-semibold text-red-500 font-mono ">
                Only allow JPG,JPEG and PNG
              </h2>
            </div>

            <button
              type="submit"
              className="w-full text-center py-3 rounded bg-green-500 text-white hover:bg-green-600 focus:outline-none my-1"
            >
              Create Account
            </button>
          </div>
        </div>
      </form>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:p-10 p-4 bg-gradient-to-r from-indigo-100 via-purple-300 to-pink-100">
        {nurseData &&
          nurseData.map((data) => {
            const { _id, name, email, mobile, designation, place, filePath } =
              data;

            return (
              <div key={_id} className=" p-5 shadow-xl flex justify-between">
                <div>
                  <h1 className="font-bold capitalize md:text-lg">{name}</h1>
                  <h1>{designation}</h1>
                  <h1>{mobile}</h1>
                  <h1>{email}</h1>
                  <h1>{place}</h1>

                  <img
                    className="w-20 h-20 rounded-full ring-2 ring-gray-300"
                    src={`${filePath}`}
                    alt="nursephoto"
                  />
                </div>
                <button
                  className="font-bold text-2xl hover:text-red-700 transition-all duration-200"
                  onClick={() => {
                    handleDelete(_id);
                  }}
                >
                  <RiDeleteBin5Fill />
                </button>
              </div>
            );
          })}
      </div>
    </>
  );
};

export default NurseSingup;
